export class DesignationIdReq {
    designationId: number;
    constructor(designationId: number) {
        this.designationId = designationId;
    }
}